"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function useTimeout(fn, time) {
    react_1.default.useEffect(function () {
        var timeout = setTimeout(fn, time);
        return function cleanup() {
            clearTimeout(timeout);
        };
    }, []);
}
exports.useTimeout = useTimeout;
//# sourceMappingURL=use-timeout.js.map